import React from 'react';
import PropTypes from 'prop-types';
// import { Link as RouterLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

import { ADGMImage } from 'aurora-components';

import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

function NoData(props) {
  const { classes } = props;

  return (
    <div className={classes.transactionsNotification}>
      <div className={classes.infoMessageTooltip}>
        <ADGMImage name='Information.svg' alt='information' />
        {keyEmptyCheck('no_projects_yet')}
        <strong>
          <a target='_blank' href='https://www.adgm.com/contact-us/make-enquiry' rel='noreferrer'>
            <FormattedMessage {...messages.contact_us_now} />
          </a>
        </strong>
      </div>
      <figure>
        <ADGMImage name='emptystate1.png' alt='empty-state' />
      </figure>
      <div className={classes.tcTextHolder}>
        <Typography variant='body1' component='h1' className={classes.title}>
          {keyEmptyCheck('no_projects_title')}
        </Typography>
        <Typography variant='body1'>{keyEmptyCheck('no_projects_subtitle')}</Typography>
      </div>
    </div>
  );
}

NoData.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NoData);
